import { useMemo } from 'react';
import { useAppSelector } from '../../../state/store';
import { getCurrentLocation, getSensorsById } from '../../../state/selectors';
import { SensorLatest } from '../../../services/api';

export default function useSensorDetailsInLoc(): SensorLatest[] {
  const sensorsById = useAppSelector(getSensorsById);
  const currentLocation = useAppSelector(getCurrentLocation);

  // all available sensors in location and sub locations
  const sensorsDetailsInLoc = useMemo(
    () =>
      Array.from(sensorsById.values()).filter(
        (item) =>
          currentLocation === '#' ||
          item.location === currentLocation ||
          item.location?.startsWith(`${currentLocation}#`)
      ),
    [currentLocation, sensorsById]
  );

  return sensorsDetailsInLoc;
}
